module.exports = __webpack_public_path__ + "media/images/service/s_3-f36eeb6468a7c1ba86ea56a97b38f7e4.png";